"use strict";

exports.__esModule = true;
var _TicketingContext = require("./TicketingContext");
Object.keys(_TicketingContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TicketingContext[key]) return;
  exports[key] = _TicketingContext[key];
});
var _TicketDetails = require("./TicketDetails");
Object.keys(_TicketDetails).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TicketDetails[key]) return;
  exports[key] = _TicketDetails[key];
});
var _TicketListScreen = require("./TicketListScreen");
Object.keys(_TicketListScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TicketListScreen[key]) return;
  exports[key] = _TicketListScreen[key];
});
var _TicketGrid = require("./TicketGrid");
Object.keys(_TicketGrid).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TicketGrid[key]) return;
  exports[key] = _TicketGrid[key];
});
var _TicketRoutes = require("./TicketRoutes");
Object.keys(_TicketRoutes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TicketRoutes[key]) return;
  exports[key] = _TicketRoutes[key];
});
var _TicketScreenToolbar = require("./TicketScreenToolbar");
Object.keys(_TicketScreenToolbar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TicketScreenToolbar[key]) return;
  exports[key] = _TicketScreenToolbar[key];
});
var _TicketWatcherRuleListScreen = require("./TicketWatcherRuleListScreen");
Object.keys(_TicketWatcherRuleListScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TicketWatcherRuleListScreen[key]) return;
  exports[key] = _TicketWatcherRuleListScreen[key];
});
var _UpdateTicketWatcherRuleScreen = require("./UpdateTicketWatcherRuleScreen");
Object.keys(_UpdateTicketWatcherRuleScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UpdateTicketWatcherRuleScreen[key]) return;
  exports[key] = _UpdateTicketWatcherRuleScreen[key];
});
var _CreateTicketWatcherRuleScreen = require("./CreateTicketWatcherRuleScreen");
Object.keys(_CreateTicketWatcherRuleScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CreateTicketWatcherRuleScreen[key]) return;
  exports[key] = _CreateTicketWatcherRuleScreen[key];
});
var _TicketWatcherRuleForm = require("./TicketWatcherRuleForm");
Object.keys(_TicketWatcherRuleForm).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TicketWatcherRuleForm[key]) return;
  exports[key] = _TicketWatcherRuleForm[key];
});